import React,{Component,useState,useEffect} from 'react';
import { Link ,useHistory} from 'react-router-dom';
import "./Header.css";
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DehazeIcon from '@mui/icons-material/Dehaze';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useStateValue } from './StateProvider';
import { auth ,db} from './firebase';
import Skwhite from './Skwhite.jpeg'
import { Modal, Button } from 'react-bootstrap';
import swal from 'sweetalert';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
function Header() {
  const history=useHistory()
    const [{basket,user},dispatch]=useStateValue();
    const [showModal, setShowModal] = useState(false);
    const [searchText,setSerchText]=useState('')

    const submitSearch=(e)=>{
        e.preventDefault();
        if(searchText===''){
          swal("","Please type some words to search","error")
        }else{
          history.push(`/search/products/${searchText}`)
        }
    }

    useEffect(() => {
      if(user){
        db.collection('register')
        .doc(user.uid)
        .get().then((doc)=>{
        }).catch((err)=>{
          console.log(err)
        })
      }
      
    }, [user])

    const login=()=>{
        if(user){
            auth.signOut();
            history.push('/')
        }
    }
    const close=()=>{
      setShowModal(false)
    }

    return (
      <>
        <nav className="header" id="#top">
        <Modal  className='modal__position'
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Modal.Header style={{backgroundColor:'#000000'}}>
          <Modal.Title>
          <ul className="navbar-nav">
          <CloseRoundedIcon onClick={close} className='header__close'/>
          {user?
            <Link className='text-decoration-none header__link' onClick={close} to='/profile'>
            <li >
            <h5 className='text-white mt-1 text-center'>View Profile</h5>
            <h6 className="t mt-3 ml-1 text-white text-center"><span><AccountCircleIcon /></span>   Hello, {user ? user.email : ' Guest'}</h6>
            </li>
            </Link>
            :
            <li>
            <h6 className="t mt-3 ml-1 text-white text-center"><span><AccountCircleIcon /></span>   Hello, {user ? user.email : ' Guest'}</h6>
            </li>
            }
          </ul>          
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <ul className="navbar-nav">
              <Link to={`${user?'':'/login'}`} className="header__link text-dark text-decoration-none align-self-start">
                <li className='mb-2'>
                  <span className="t mt-3 category " onClick={login}>{user ? 'Sign out' : 'Sign in'}</span>
                </li>
              </Link>
              {
                user&&user.email==='sk7816207@gmail.com'&&
                <Link to="/admin" className="header__link text-dark text-decoration-none align-self-start" >
                <div className="header__option ml-3 mb-1 category">
                  <span onClick={close}>Admin</span>
                </div>
              </Link>
              }
              <Link to="/orders" className="header__link text-dark text-decoration-none align-self-start" >
                <div className="header__option ml-3 mb-1 category">
                  <span onClick={close}>Returns & orders</span>
                </div>
              </Link>

              <li>
                <h5 className="t mt-3">Shop By category</h5>
              </li>
              <Link to='/all' className='text-dark text-decoration-none align-self-start'>
                  <li className="nav-item d-flex">
                    <span className="nav-link text-dark t category" onClick={close}>All products</span>
                  </li>
              </Link>
              <Link to="/C1" className='text-decoration-none align-self-start'>
                <li className="nav-item d-flex">
                  <span className="nav-link text-dark t category" onClick={close}>Fruits & Vegitables</span>
                </li>

              </Link>
              <Link to="/C2" className='text-decoration-none align-self-start'>
                <li className="nav-item d-flex">
                  <span className="nav-link text-dark t category" onClick={close}>Bakery , Cakes & Dairy</span>
                </li>
              </Link>

              <Link to="/C3" className='text-decoration-none align-self-start'>
              <li className="nav-item d-flex">
                <span className="nav-link text-dark t category" onClick={close}>Foodgrains, oil & masala</span>
              </li>
              </Link>
              <Link to="/C4" className='text-decoration-none align-self-start'>
              <li className="nav-item d-flex">
                <span className="nav-link text-dark t category" onClick={close }>Beverages</span>
              </li>
              </Link>
             
              <Link to="/C5" className='text-decoration-none align-self-start'>
              <li className="nav-item d-flex">
                <span className="nav-link text-dark t category" onClick={close} >Snacks</span>
              </li>
              </Link>
            
            </ul>
        </Modal.Body>
      </Modal>
          <span className='ml-3 text-white'>
            <DehazeIcon style={{fontSize:'28px'}} onClick={()=>{setShowModal(true)}}/>
          </span>
         
          <Link to="/" className="dvv">
            <img width='5px' height='40px' className="header__logo" src={Skwhite} alt="logo" ></img>
          </Link>
          <form onSubmit={submitSearch} className="header__search">
            <input  placeholder='Search' className='pl-3 w-100' type='text' onChange={(e)=>{setSerchText(e.target.value)}}/>
                <SearchIcon onClick={submitSearch} className='header__searchIcon'/>
          </form>
          <div className="header__nav">
            <Link to={`${user?'':'/login'}`} className="header__link text-decoration-none" id='signorder1'>
              <div onClick={login} className="header__option">
                <span className="header__optionLineOne">Hello, {!user ? "Guest" :user.email}</span>
                <span className="header__optionLineTwo so">{user ? 'sign out' : 'sign in'}</span>
              </div>
            </Link>
            <Link to="/orders" className="header__link text-decoration-none" id='signorder2'>
              <div className="header__option">
                {/* <span className="header__optionLineOne">Returns</span> */}
                <span className="header__optionLineTwo mt-1">orders</span>
              </div>
            </Link>
                       {/* <Link to="/"className="header__link">
                   <div className="header__option">
                       <span className="header__optionLineOne">Your</span>
                       <span className="header__optionLineTwo">Prime</span>
                   </div>
               </Link> */}
            <Link to="/checkout" className="header__optionBasket">
              <div className="header__link cart">
                <ShoppingCartIcon />
                <span className="header__optionLineTwo header__basketCount">{basket?.length}</span>
              </div>
            </Link>
          </div>
        </nav>
        <nav className="search2">
          <form onSubmit={submitSearch} className="header__search2">
            <input placeholder='Search . . .' className='p-3 dropdown_list header__searchInput2' onChange={(e)=>{setSerchText(e.target.value)}}/>
            <SearchIcon onClick={submitSearch} className='header__searchIcon2' />
          </form>
        </nav>
    
      </>
        
       
    );
}

export default Header;
